import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Swiper from 'swiper';
import {  Autoplay , Navigation, Pagination , FreeMode } from 'swiper/modules';



function hscroll() {
    const h_scroll = document.querySelector('[data-target="h_scroll"]');
   
    if (!h_scroll) { return; }
    const h_scroll_list = document.querySelector('[data-target="h_scroll_list"]');
    const h_scroll_list_next = h_scroll_list.querySelector('.swiper-button-next')
    const h_scroll_list_prev = h_scroll_list.querySelector('.swiper-button-prev')
    
    const paddingleft = h_scroll.getBoundingClientRect().left;
    

    const slider = new Swiper ('[data-target="h_scroll_slider"]', {
        modules: [Navigation, Pagination, Autoplay, FreeMode],
        slidesPerView: 1.5,
        freeMode:true,
        spaceBetween: 30,
        loop: true,
        slidesOffsetBefore: paddingleft,
        speed: 700,
        breakpoints: {
            1024: {
                slidesPerView: 5.5,
            },
            768: {
                slidesPerView: 2.5,
                spaceBetween: 30,
            },
            
      },
        allowTouchMove: true,
        navigation: {
            nextEl: h_scroll_list_next,
            prevEl: h_scroll_list_prev,
          },
        }); 
            
       
        

    
    
}


export { hscroll }; 